var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2V3.5",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2V3.5",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C13.1046 3 14 3.89543 14 5V9.88281C13.7349 9.64477 13.3845 9.5 13 9.5C12.6155 9.5 12.2651 9.64477 12 9.88281V5.90039C12 5.67948 11.8205 5.5 11.5996 5.5H10.4004C10.1795 5.5 10 5.67948 10 5.90039V11.0996C10 11.3205 10.1795 11.5 10.4004 11.5H10.5869C10.5314 11.6564 10.5 11.8244 10.5 12C10.5 12.6772 10.9491 13.2481 11.5654 13.4346C11.6297 13.647 11.7405 13.8388 11.8848 14H4C2.89543 14 2 13.1046 2 12V5C2 3.89543 2.89543 3 4 3H12ZM4.40039 5.5C4.17948 5.5 4 5.67948 4 5.90039V11.0996C4 11.3205 4.17948 11.5 4.40039 11.5H5.59961C5.82052 11.5 6 11.3205 6 11.0996V5.90039C6 5.67948 5.82052 5.5 5.59961 5.5H4.40039ZM7.40039 5.5C7.17948 5.5 7 5.67948 7 5.90039V11.0996C7 11.3205 7.17948 11.5 7.40039 11.5H8.59961C8.82052 11.5 9 11.3205 9 11.0996V5.90039C9 5.67948 8.82052 5.5 8.59961 5.5H7.40039Z",
    fill: "#002A69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H14M13 11V13",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSchedule);
export default __webpack_public_path__ + "static/media/Add_schedule.bbb54e69797108aa68ddcae33ebbea93.svg";
export { ForwardRef as ReactComponent };